const configuration = require("config");
const log = require("../lib/utils/commons").log;
/**
 * Utility method to load value from configuraiton file for provided key
 * @param {String} key
 */
const getConfig = (key) => {
  let value;
  if (configuration.has(key)) {
    value = configuration.get(key);
  } else {
    log.error(`${key} - does not exists in configuration`);
  }
  return value;
};

/**
 * Application environment. NODE_CONFIG_ENV value is set through CLI
 * */
const APP_ENV = configuration.util.getEnv("NODE_CONFIG_ENV");

/**
 * Indicate if application is running in development mode.
 */
const IS_DEV = process.env.NODE_ENV === "development";
const IS_IT = APP_ENV === "it";
const IS_BUSINESS_UNIT_CG = process.env.BUSINESS_UNIT === "CG";

module.exports = Object.freeze({
  getConfig,
  APP_ENV,
  IS_DEV,
  IS_IT,
  IS_BUSINESS_UNIT_CG
});
